export default {
    "entityName": "protocol_has_site",
    "title": "Protocol site",
    id: ['protocol_id', 'site_id'],
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "site_id",
        "descending": true
    },
    "fields": [
        {
            "value": "site.city",
            "text": "Site",
            title: "city",
            subtitle: item => `${item.name} - ${item.code}`,
            readonly: true,
            // type: "autocomplete",
            filter: (item, search) => [{ 'site.city': `%${search}%` }, {'site.name': `%${search}%`}, { 'site.code': `%${search}%`}],
            "table": {
                "sortable": true,
                filter: true
            },
            render: item => `${item.site.city} - ${item.site.name}`,
            validators: ['required'],
        },
        {
            "value": "account_id",
            "text": "Account",
            "type": "autocomplete",
            "title": item => `${item.name} ${item.surname}`,
            multiple: true,
            deps: ['site_id'],
            "subtitle": "email",
            'filter': (item, search) => {
                //issue 341
                if (search) {
                    return {status: 'Active' , role: 'Site', site_id: item.site_id, name: `%${search}%`}
                }
                return {status: 'Active' , role: 'Site', site_id: item.site_id}
                //issue 341
            },
            readonly: item => !item.site_id,
            //validators: ['required'],
        },
        {
            value: 'site.code',
            id: 'code',
            type: 'autocomplete',
            reference: 'site',
            text: 'Code',
            table: { filter: true },
            title: 'code',
            visible: false
        },
        {
            "value": "address",
            "text": "Address",
            "type": "text",
            readonly: true,
            deps: ['pharmacy_id'],
            default: (item, updatedField, selectedItem) => {
                if (updatedField.value === 'pharmacy_id') {
                    return selectedItem && `${selectedItem.address} ${selectedItem.city} (${selectedItem.cap})`
                }
            }
        },
        {
            "value": "country",
            "text": "Country",
            "type": "text",
            readonly: true,
            deps: ['pharmacy_id'],
            // render: item => item.pharmacy.country,
            // type: 'hidden',
            // table: {
            //     filter: true
            // },
            // filter: (item, search) => ({ 'site.country_code': `%${search}%` }),
            default: (item, updatedField, selectedItem) => {
                if (updatedField.value === 'pharmacy_id') {
                    return selectedItem && selectedItem.country
                }
            },
        },
        {
            "value": "site.country_code",
            "name": "country_code",
            "text": "Country",
            "type": "text",
            readonly: true,
            render: item => item.site.country_code,
            table: {
                filter: true
            },
            visible: false,
            // filter: (item, search) => ({ 'site.country_code': `%${search}%` }),
            // default: (item, updatedField, selectedItem) => {
            //     if (updatedField.value === 'pharmacy_id') {
            //         return selectedItem && selectedItem.country
            //     }
            // },
        },
        {
            "value": "name_pi",
            "text": "Name PI",
            "type": "text",
        },
        {
            "value": "surname_pi",
            "text": "Surname PI",
            "type": "text",
        },
        {
            "value": "email_pi",
            "text": "Email PI",
            "type": "text",
            "validators": [
                "email"
            ],
        },
        {
            "value": "phone_pi",
            "text": "Phone PI",
            "type": "text",
        },
        {
            "value": "pharmacy_id",
            "reference": "pharmacy",
            "text": "Pharmacy",
            "type": "autocomplete",
            "title": "name",
            "subtitle": "email",
            deps: ['site_id'],
            'filter': item => ({ site_id: item.site_id}),
            readonly: item => !item.site_id,
            validators: ['required'],
        },
        {
            "value": "reference_pharmacy_id",
            "text": "Reference",
            id: 'id',
            "reference": "reference",
            "type": "autocomplete",
            "title": item => `${item.name} ${item.surname}`,
            "subtitle": "email",
            deps: ['pharmacy_id', 'site_id'],
            'filter': item => ({ pharmacy_id: item.pharmacy_id}),
            readonly: item => !item.pharmacy_id,
            validators: ['required']
        },        
        {
            "value": "could_return",
            "text": "Could return",
            table: true,
            type: "check"
        }   
    ],
    "actions": [
        "upsert",
        { "value": "sitecode", "text": "Provider codes", "color": "primary", "icon": "mdi-dialpad" },
        'audit'
    ]
}